import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faLink, faServer } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Header from "../Shared/Header/Header";
import "./ProjectDetail.css";

const ProjectDetail = () => {
  const { projectId } = useParams();
  const [Project, setProject] = useState([]);
  useEffect(() => {
    fetch("/projectsData.json")
      .then((res) => res.json())
      .then((data) => {
        const FindProject = data.find((d) => d.id === projectId);
        setProject(FindProject);
      });
  }, [projectId]);
  return (
    <div>
      <Container className="py-3">
        <Row>
          <Col md={12}>
            <div className="slider-container">
              <Carousel variant="dark">
                {Project?.images?.map((IMG, index) => (
                  <Carousel.Item key={index}>
                    <img
                      className="d-block w-100"
                      src={IMG}
                      alt="Third slide"
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          </Col>
          <Col md={12} className="mt-5">
            <h2>Project Name: {Project?.name}</h2>
            <div className="d-flex align-items-center justify-content-center">
              <h5>
                Live Site :
                <a href={Project?.liveSite} rel="noopener noreferrer">
                  <span className="project-link">
                    <FontAwesomeIcon icon={faLink} className="detail-icon" />
                  </span>
                </a>
              </h5>

              <h5>
                {" "}
                Client Site:
                <a href={Project?.clientSite} rel="noopener noreferrer">
                  <span>
                    <FontAwesomeIcon icon={faGithub} className="detail-icon" />
                  </span>
                </a>
              </h5>

              <div>
                {Project?.serverSite && (
                  <h5>
                    Server Site:
                    <a href={Project?.serverSite} rel="noopener noreferrer">
                      <span className="project-link">
                        <FontAwesomeIcon
                          icon={faServer}
                          className="detail-icon"
                        />
                      </span>
                    </a>
                  </h5>
                )}
              </div>
            </div>

            <p className="mb-2">
              {" "}
              <span className="fw-bolder">Technology Used :</span>
              {Project?.tools}
            </p>
            <p className="mb-1">
              {" "}
              <span className="fw-bolder">Description :</span>{" "}
              {Project?.details}
            </p>
            <ul>
              {Project?.li?.map((l) => (
                <li key={l}>{l}</li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProjectDetail;
